import * as types from '../types/adTypes';
import * as adService from '../../services/adService';
import { getApiCountryCode } from '../../services/http';
import { makeServerEventKey } from '../../utils/adTracking';

export const adPlacementKey = (page, placement, scope = '') => `${page}:${placement}:${scope || 'global'}`;

export const fetchAdPlacement = ({ page, placement, scope = '', params = {} }) => async (dispatch) => {
  const key = adPlacementKey(page, placement, scope);
  dispatch({ type: types.FETCH_AD_PLACEMENT_REQUEST, meta: { key } });
  try {
    const mergedParams = {
      ...params,
      page: params.page != null && params.page !== '' ? params.page : page,
      placement: params.placement != null && params.placement !== '' ? params.placement : placement,
    };
    const data = await adService.getAdPlacements(mergedParams);
    dispatch({ type: types.FETCH_AD_PLACEMENT_SUCCESS, payload: data, meta: { key } });
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Failed to fetch ad placement';
    dispatch({ type: types.FETCH_AD_PLACEMENT_FAILURE, payload: message, meta: { key } });
  }
};

export const trackAdImpression = (payload) => async (dispatch) => {
  dispatch({ type: types.TRACK_AD_EVENT_REQUEST });
  try {
    const merged = { ...payload, country: payload.country || getApiCountryCode() || '' };
    const eventKey = merged.eventKey || makeServerEventKey(merged, 'impression');
    await adService.trackAdImpression({ ...merged, eventKey });
    dispatch({ type: types.TRACK_AD_EVENT_SUCCESS });
  } catch (_error) {
    dispatch({ type: types.TRACK_AD_EVENT_FAILURE });
  }
};

export const trackAdClick = (payload) => async (dispatch) => {
  dispatch({ type: types.TRACK_AD_EVENT_REQUEST });
  try {
    const merged = { ...payload, country: payload.country || getApiCountryCode() || '' };
    const eventKey = merged.eventKey || makeServerEventKey(merged, 'click');
    await adService.trackAdClick({ ...merged, eventKey });
    dispatch({ type: types.TRACK_AD_EVENT_SUCCESS });
  } catch (_error) {
    dispatch({ type: types.TRACK_AD_EVENT_FAILURE });
  }
};
